export interface NavItem {
  icon: string;
  iconSet: 'material-icons' | 'material-symbols-outlined';
  label: string;
  route: string; // empty string currently represents root/home or TBD routes
  description?: string; // optional description for home modules
  hide?: boolean; // if true, item should not appear in sidebar nor home modules
}

export const NAV_ITEMS: NavItem[] = [
  {
    icon: 'inbox_text',
    iconSet: 'material-symbols-outlined',
    label: 'Document Repository',
    route: '/document-repository',
    description: 'Central repository for all BCR related documents.',
  },
  {
    icon: 'id_card',
    iconSet: 'material-symbols-outlined',
    label: 'Legal Entity List',
    route: '/legal-entity-list',
    description:
      'A duplicate list from the legal entity dashboard that includes signatory names and statuses.',
  },
  {
    icon: 'ink_pen',
    iconSet: 'material-symbols-outlined',
    label: 'Signatory List',
    route: '/signatory-list',
    description: 'A list of all BCR signatories.',
  },
  {
    icon: 'quick_reference_all',
    iconSet: 'material-symbols-outlined',
    label: 'Management Tool Audit Trail',
    route: '',
    description: 'View a history of system actions.',
    hide: true,
  },
  {
    icon: 'event_available',
    iconSet: 'material-symbols-outlined',
    label: 'Annual Review',
    route: '',
    description: 'Record yearly assessments to ensure ongoing compliance.',
    hide: true,
  },
  {
    icon: 'verified_user',
    iconSet: 'material-symbols-outlined',
    label: 'Annual Assurance Review',
    route: '',
    description: 'Verify annual compliance and standards.',
    hide: true,
  },
  {
    icon: 'inbox_text_asterisk',
    iconSet: 'material-symbols-outlined',
    label: 'Template Repository',
    route: '',
    description: 'Browse and download standardized templates for consistent documentation.',
    hide: true,
  },
];
